import { cn } from "@/lib/utils/cn";
import { generateSkeletonArray } from "@/lib/utils/skeletonUtils";
import { SkeletonBase } from "./SkeletonBase";

/**
 * Form skeleton loader
 * @param {Object} props - Component props
 * @param {number} props.fields - Number of form fields to display (default: 4)
 * @param {boolean} props.hasSubmitButton - Whether to show submit button skeleton (default: true)
 * @param {string} props.className - Additional CSS classes
 */
export function FormSkeleton({ fields = 4, hasSubmitButton = true, className }) {
  const fieldArray = generateSkeletonArray(fields);

  return (
    <div className={cn("space-y-4", className)}>
      {fieldArray.map((index) => (
        <div key={`field-${index}`} className="space-y-2">
          {/* Label skeleton */}
          <SkeletonBase variant="line" className="h-4 w-32" />
          {/* Input skeleton */}
          <SkeletonBase variant="block" className="h-10 w-full" />
        </div>
      ))}

      {/* Submit button skeleton */}
      {hasSubmitButton && (
        <div className="pt-4">
          <SkeletonBase variant="block" className="h-10 w-32" />
        </div>
      )}
    </div>
  );
}
